<template>
  <div class="contain padc">
    <div class="layout-desc-check">
      <div class="content-desc-check">
        <div class="ele-addvisit"><span class="label-add-visit">客户中文名称</span><input type="text"
                 class="text-addvisit"
                 v-model="customer.name"
                 readonly></div>

        <div class="ele-addvisit"><span class="label-add-visit">行业</span><input type="text"
                 class="text-addvisit"
                 readonly
                 v-model="customer.trade"></div>

        <div class="ele-addvisit"><span class="label-add-visit">公司性质</span><input type="text"
                 class="text-addvisit"
                 readonly
                 v-model="customer.companyType"></div>

        <div class="ele-addvisit"><span class="label-add-visit">投资国/地区</span><input type="text"
                 class="text-addvisit"
                 readonly
                 v-model="customer.nationality"></div>
        <div class="ele-addvisit"><span class="label-add-visit">地址</span><input type="text"
                 class="text-addvisit"
                 readonly
                 v-model="customer.address"></div>

        <div class="ele-addvisit"><span class="label-add-visit">电话</span><input type="text"
                 class="text-addvisit"
                 readonly
                 v-model="customer.tel"></div>

        <div class="ele-addvisit"><span class="label-add-visit">信息来源</span><input type="text"
                 class="text-addvisit"
                 readonly
                 v-model="customer.source"></div>
        <div class="ele-addvisit"><span class="label-add-visit">客户类型</span><input type="text"
                 class="text-addvisit"
                 readonly
                 v-model="customer.custType"></div>
      </div>
    </div>
    <!--模块-->
    <div class="layout-desc-check">
      <div class="content-desc-check">
        <div class="ele-addvisit"><span class="label-add-visit">销售员</span><span class="info-desc-check">{{this.customer.salesName}}</span></div>
        <!--元素-->
        <!-- <div class="ele-addvisit noborderb"><span class="label-add-visit">部门</span>
          <div class="content-sel-addvisit"><input type="text"
                   class="text-addvisit"
                   readonly></div>
        </div> -->
        <!--元素-->
      </div>
    </div>
    <!--模块-->
    <div class="layout-desc-check" style="padding-bottom:1rem">
      <div class="tit-desc-check color-nol">联系人</div>
      <div class="content-desc-check cotent-contact-check"
           v-for="p in connecter.data"
           :key="p.id">
        <div @click="showConnecter(p.id)">
          <div class="ele-desc-check"><span class="label-desc-check">姓名</span><span class="info-desc-check">{{p.connectName}}</span></div>
          <div class="ele-desc-check"><span class="label-desc-check">三名片</span><span class="info-desc-check">{{p.card}}</span></div>
          <div class="ele-desc-check"><span class="label-desc-check">电话</span><span class="info-desc-check">{{p.tel}}</span></div>
          <div class="ele-desc-check"><span class="label-desc-check">负责人</span><span class="info-desc-check">{{p.sal}}</span></div>
        </div>
      </div>
    </div>
    <ApproveBottom :approveType="approveParam.customer" :id="id"></ApproveBottom>
    <!--模块-->
    <van-popup v-model="popConn.show"
               :style="{ height: popConn.popHeight }">
      <div class="contain">
        <div class="layout-desc-check">
          <div class="content-desc-check">
            <div class="ele-addvisit"><span class="label-add-visit">联系人姓名</span><input type="text"
                     class="text-addvisit"
                     v-model="connecter.name"
                     readonly
                     required></div>
            <div class="ele-addvisit"><span class="label-add-visit">性别</span><input type="text"
                     class="text-addvisit"
                     readonly
                     v-model="connecter.sex"
                     required></div>
            <!-- <div class="ele-addvisit"><span class="label-add-visit">生日</span><input type="text"
                     class="text-addvisit"
                     readonly
                     v-model="connecter.birthday"
                     required></div> -->
            <!--元素-->
            <div class="ele-addvisit"><span class="label-add-visit">三名片</span><input type="text"
                     class="text-addvisit"
                     readonly
                     v-model="connecter.card"
                     required></div>
            <!--元素-->
            <div class="ele-addvisit"><span class="label-add-visit">职务</span><input type="text"
                     class="text-addvisit"
                     v-model="connecter.position"
                     readonly
                     required></div>
            <!--元素-->
            <div class="ele-addvisit"><span class="label-add-visit">电话</span><input type="text"
                     class="text-addvisit"
                     v-model="connecter.tel"
                     readonly
                     required></div>
            <!--元素-->
            <div class="ele-addvisit"><span class="label-add-visit">就职状态</span><input type="text"
                     class="text-addvisit"
                     readonly
                     v-model="connecter.status"
                     required></div>
            <!--元素-->
            <div class="ele-addvisit"><span class="label-add-visit">负责人</span><input type="text"
                     class="text-addvisit"
                     v-model="connecter.sal"
                     readonly
                     required></div>
          </div>
        </div>
        <!--模块-->

        <div class="content-btn-check"
             style="border-top:0">
          <button class="del-desc-check"
                  @click="hideConnecter">关闭</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import ApproveBottom from '../../components/approve/ApproveBottom.vue'
import customerModel from '../../api/model/customer'
import { mapState } from 'vuex'
export default {
  name: 'CustomerInfo',
  components:{
    ApproveBottom
  },
  data() {
    return {
      //系统参数
      pickerSet: 'pickerSet', //选择器
      timePickerSet: 'timePickerSet', //时间选择器
      connAdd: 'connAdd',
      //客户信息
      customer: {
        name: '', //客户名称
        address: '', //地址
        tel: '', //电话
        trade: '', //行业
        source: '', //信息来源
        nationality: '', //投资国
        companyType: '', //企业类型
        salesName:'',//销售员名称
        custType:'',//客户类型
      },
      //联系人弹出
      popConn: {
        show: false, //是否显示POP
        operType: 0, //POP类型 根据类型不同显示不同数据 具体类型看上面template
        title: '', //POP标题
        list: [], //POP下拉数据
        popHeight: '60%', //高度
      },
      //联系人
      connecter: {
        id: '',
        data: [], //添加的联系人数据
        name: '', //联系人名称
        position: '', //联系人职务
        tel: '', //联系人电话
        birthday: '', //生日
        card: '', //三名片
        status: '', //就职状态
        sex: '', //性别
        sal:'',//负责销售
      },
    }
  },
  props: ['id'],
  methods: {
    async GetCustomerInfo() {
      const res = await customerModel.getCustomerById({ id: this.id })
      if (res.success) {
        this.customer.name=res.data.customerName
        this.customer.address=res.data.address
        this.customer.tel=res.data.tel
        this.customer.trade=res.data.trade
        this.customer.nationality=res.data.nationality
        this.customer.source=res.data.source
        this.customer.companyType=res.data.companyType
        this.customer.salesName=res.data.salesmanName
        this.customer.custType=res.data.custType
      } else {
        this.$toast(res.msg)
      }
    },
    async GetConnecter() {
      const res = await customerModel.getCustomerConnecterList({ custId: this.id })
      if (res.success) {
        this.connecter.data=res.data
      } else {
        this.$toast(res.msg)
      }
    },
    showConnecter(id) {
      this.connecter.data.forEach((p) => {
        if (p.id == id) {
          this.connecter.card = p.card
          this.connecter.status = p.status
          this.connecter.sex = p.sex
          this.connecter.name = p.connectName
          this.connecter.position = p.position
          this.connecter.tel = p.tel
          this.connecter.birthday = p.birthday
          this.connecter.sal=p.sal
          return false
        }
      })
      this.popConn.show = true
    },
    hideConnecter() {
      this.popConn.show = false
    },
  },
  mounted() {
    this.GetCustomerInfo()
    this.GetConnecter();
  },
  computed: {
    ...mapState('userAbout', ['salesName']),
    ...mapState('systemAbout', ['approveParam']),
    
  },
}
</script>
<style scoped>
</style>